module.exports = __webpack_public_path__ + "img/5e28fadab2ebbe95da17ba4db21b68fd.png";